import React, { useRef }  from 'react';
import { Card, Button  } from 'react-bootstrap';
import { Scatter } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart } from 'chart.js';
import { useSelector } from 'react-redux';
import { useReactToPrint } from 'react-to-print';

Chart.register(ChartDataLabels);

const DoppiaMatriceMaterialita = () => {

const contentRef = useRef(null);
// const handleScatterPrint = useReactToPrint({ contentRef });


  const handleScatterPrint = useReactToPrint({
    contentRef,
    documentTitle: 'Doppia matrice di materialità',
    pageStyle: `@media print {
        @page {
          size: landscape;
          margin: 0;
        }
        body {
          width: 100%;
        }
        #scatter-print {
          width: 100%;
        }
      }`,
  });



  

  const rilevanzaAmbiti = useSelector(
    (state) => state.questCorrente.rilevanzaAmbiti
  );

  const ambiti = useSelector(
    (state) => state.questCorrente.ambiti
  );

  console.log('rilevanzaAmbiti in SelezioneStakeholder: ', rilevanzaAmbiti);
/*
  const dataAmbiente = rilevanzaAmbiti
  .filter(item => (item.ambito.startsWith('CSVCE') && !(item.oi==0 && item.io==0)))
  .map(item => ({
    x: item.oi,
    y: item.io,
    label: item.ambito,
    labelPermanente: item.ambito.substring(4,7),
  }));
*/

const dataAmbiente = rilevanzaAmbiti
  .filter(item => (item.ambito.startsWith('CSVCE') && !(item.oi === 0 && item.io === 0)))
  .map(item => {
    const ambitoDescrizione = ambiti.find(ambito => ambito.key === item.ambito)?.descrizione;
    return {
      x: item.oi,
      y: item.io,
      labelOne: item.ambito,
      labelPermanente: `${item.ambito.substring(4,7)} - ${ambitoDescrizione}`
    };
  });

/*
  const dataGovernance = rilevanzaAmbiti
  .filter(item => (item.ambito.startsWith('CSVCG') && !(item.oi==0 && item.io==0)))
  .map(item => ({
    x: item.oi,
    y: item.io,
    label: item.ambito,
    labelPermanente: item.ambito.substring(4,7),
  }));
*/
const dataGovernance = rilevanzaAmbiti
  .filter(item => (item.ambito.startsWith('CSVCG') && !(item.oi === 0 && item.io === 0)))
  .map(item => {
    const ambitoDescrizione = ambiti.find(ambito => ambito.key === item.ambito)?.descrizione;
    return {
      x: item.oi,
      y: item.io,
      labelOne: item.ambito,
      labelPermanente: `${item.ambito.substring(4,7)} - ${ambitoDescrizione}`
    };
  });

/*
  const dataSociale = rilevanzaAmbiti
  .filter(item => (item.ambito.startsWith('CSVCS') && !(item.oi==0 && item.io==0)))
  .map(item => ({
    x: item.oi,
    y: item.io,
    label: item.ambito
  }));
*/
const dataSociale = rilevanzaAmbiti
  .filter(item => (item.ambito.startsWith('CSVCS') && !(item.oi === 0 && item.io === 0)))
  .map(item => {
    const ambitoDescrizione = ambiti.find(ambito => ambito.key === item.ambito)?.descrizione;
    return {
      x: item.oi,
      y: item.io,
      labelOne: item.ambito,
      labelPermanente: `${item.ambito.substring(4,7)} - ${ambitoDescrizione}`
    };
  });
  
    const data = {
        datasets: [
          {
            label: 'Ambiente',
            data: dataAmbiente,
            backgroundColor: 'green',
            pointRadius: 7, // Dimensione dei punti
          },
          {
            label: 'Governance',
            data: dataGovernance,
            backgroundColor: 'blue',
            pointRadius: 7, // Dimensione dei punti
          },
          {
            label: 'Sociale',
            data: dataSociale,
            pointRadius: 7, // Dimensione dei punti
            backgroundColor: 'red',
          },
        ],
    };
    

    const options = {
      scales: {
        x: {
          title: {
            display: true,
            text: 'RILEVANZA OUTSIDE IN',
            font: {
              weight: 'bold',
              size: 18,
              color: '#0000FF',
            }
          },
          min: 0,
          max: 100,
          ticks: {
            callback: function(value) {
              if (value === 10) {
                return 'Bassa';
              } else if (value === 30) {
                return 'Moderata';
              } else if (value === 50) {
                return 'Media';
              } else if (value === 70) {
                return 'Alta';
              } else if (value === 90) {
                return 'Molto alta';
              }
              return '';
            }
          },
          grid: {
            drawTicks: true,
            borderColor: function(context) {
              if (context.tick.value === 50) {
                return 'red'; // Colore dell'asse verticale evidenziato
              }
              return '#ccc';
            },
            borderWidth: function(context) {
              if (context.tick.value === 50) {
                return 2; // Spessore dell'asse verticale evidenziato
              }
              return 1;
            }
          }
        },
        y: {
          title: {
            display: true,
            text: 'RILEVANZA INSIDE OUT',
            font: {
              weight: 'bold',
              size: 18,
              color: '#0000FF',
            }
          },
          min: 0,
          max: 100,
          ticks: {
            callback: function(value) {
              if (value === 10) {
                return 'Bassa';
              } else if (value === 30) {
                return 'Moderata';
              } else if (value === 50) {
                return 'Media';
              } else if (value === 70) {
                return 'Alta';
              } else if (value === 90) {
                return 'Molto alta';
              }
              return '';
            }
          },
          grid: {
            drawTicks: true,
            borderColor: function(context) {
              if (context.tick.value === 50) {
                return 'red'; // Colore dell'asse orizzontale evidenziato
              }
              return '#ccc';
            },
            borderWidth: function(context) {
              if (context.tick.value === 50) {
                return 3; // Spessore dell'asse orizzontale evidenziato
              }
              return 3;
            }
          }
        }
      },
      plugins: {
/*
        tooltip: {
          callbacks: {
            label: (context) => {
              const label = context.raw.label;
              return label ? `${label}: (${context.raw.x}, ${context.raw.y})` : `(${context.raw.x}, ${context.raw.y})`;
            },
          },
        },
*/
        tooltip: {
          callbacks: {
            label: (context) => {
              const label = context.raw.label;
              return label ? `${label}: (${context.raw.x}, ${context.raw.y})` : `(${context.raw.x}, ${context.raw.y})`;
            },
          },
        },

        datalabels: {
          display: true,
          align: 'top',
          formatter: (value) => {
            return `${value.labelPermanente}`;
          },
          font: {
            weight: 'bold'
          }
        }
    

      },
  }; 
    
  return (<>
    <Card className="text-center"  ref={contentRef}>
      <Card.Body className="p-5">
        <h1 className="text-center">
          <strong>Doppia matrice di materialità</strong>
        </h1>
        <hr />
        <div>
          <Scatter data={data} options={options} width={300}/>
        </div>
      </Card.Body>
    </Card>
    <Button onClick={() => handleScatterPrint()}  className="mt-3">Stampa</Button>

  </>);
};

export default DoppiaMatriceMaterialita;
